export default (cardType: string) => [
  'american-express',
  'visa',
  'mastercard',
  'discover',
  'jcb',
  'diners-club',
  'ach',
].indexOf(cardType) !== -1;
